import { selectUserAccount, selectUserType } from '@/features/domain/user'
import { FormConfig, FormValidationIndicator } from '@workwave-tidal/core/form'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { RmAccountFormValues } from '../types'
import { FormFooter } from './FormFooter'
import { Apikey } from './components/fields/ApiKey'
import { Email } from './components/fields/Email'
import { Name } from './components/fields/Name'
import { Surname } from './components/fields/Surname'
import { Username } from './components/fields/Username'
import { form, initialValues } from './formState'
import { useOnSubmit } from './hooks/useOnSubmit'
import { useValidateForm } from './hooks/useOnValidate'
import { useTexts } from './hooks/useTexts'

export function RmAccountForm() {
  const texts = useTexts()
  const formValues = useSelector(selectUserAccount)
  const userType = useSelector(selectUserType)

  const accountData = useMemo<RmAccountFormValues>(() => {
    return {
      name: formValues.details.name,
      email: formValues.details.email,
      surname: formValues.details.surname,
      username: formValues.credentials.username.trim(),
    }
  }, [formValues])

  const config = useMemo<FormConfig<RmAccountFormValues>>(
    () => ({
      id: 'rm-account-form',
      initialValues: { ...initialValues, ...accountData },
    }),
    [accountData],
  )

  const onSubmit = useOnSubmit()
  const validateForm = useValidateForm(accountData.username)
  const gotAccessToApiKey = userType === 'admin'

  return (
    <form.Form
      title={texts.headerTitle}
      subtitle={texts.headerDescription}
      footer={<FormFooter />}
      onSubmit={onSubmit}
      onValidate={validateForm}
      config={config}
      requireTransaction={false}
      stopEditingOnUnmount
      applyPendingFitMapOnMount={false}
      testId="account-settings-form"
    >
      <FormValidationIndicator size={100} />

      <Name />

      <Surname />

      <Email />

      <Username />

      {gotAccessToApiKey && <Apikey />}
    </form.Form>
  )
}
